import { Cancel } from '@mui/icons-material'
import { Checkbox, FormControl, FormHelperText, Grid, IconButton, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, styled } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import { Controller, set } from 'react-hook-form'
import { Loader } from 'rsuite'
import Image from './Image'
import Images from 'assets/images'

const InputSelectFieldGrid = ({
  xs,
  name,
  size = 'small',
  control,
  required,
  label,
  data,
  style,
  formatter = (data) => data,
  onSelect = (value) => value,
  disabled = false,
  displayEmpty = false,
  multiple = false,
  render,
  onOpen,
  onClose,
  showClean,
  loading = false,
}) => {
  const [selected, setSelected] = useState([])
  const list = formatter(data);

  const LabelStyled = styled(InputLabel)(() => ({
    color: '#041C3F',
    '&.MuiInputLabel-root': {
      color: disabled ? '#BDBDBD' : '#041C3F',
    },
    '&.MuiInputLabel-shrink': {
      color: disabled ? '#BDBDBD' : '#041C3F',
    }
  }));
  const SelectStyled = styled(Select)(() => ({
    borderRadius: '8px',
    color: disabled ? '#BDBDBD' : '#041C3F',
    // height: '40px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: disabled ? '#BDBDBD' : '#041C3F',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: disabled ? '#BDBDBD' : '#041C3F',
      borderWidth: '1px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: disabled ? '#BDBDBD' : '#041C3F',
      borderWidth: '1px',
    },
  }));

  return (
    <Grid
      item
      xs={xs}
      alignContent="center"
      justifyContent={"center"}
      style={{ ...style, width: '100%' }}
    >
      <Controller
        name={name}
        control={control}
        rules={!disabled && { required }}
        render={({
          field: { value, onChange },
          fieldState: { error }
        }) => {
          if (value && multiple) {
            value = typeof value === 'string' ? value.split(',') : value
            setSelected(value)
          }
          return (
            <FormControl fullWidth size={size}>
              {
                displayEmpty ? <LabelStyled shrink>{label}</LabelStyled> : <LabelStyled>{label}</LabelStyled>
              }
              <SelectStyled
                id={name}
                value={multiple ? (selected.length === 0 ? Array.isArray(value) ? value : value ? [value] : [] : selected) : (data.length === 0 ? '' : (value === undefined ? '' : value))}
                label={label}
                multiple={multiple}
                input={displayEmpty ? <OutlinedInput notched={displayEmpty} label={label} /> : <OutlinedInput label={label} />}
                displayEmpty={displayEmpty}
                onChange={(e) => {
                  let val = e.target.value
                  if (multiple) {
                    val = typeof val === 'string' ? val.split(',') : val
                    setSelected(val)
                  }
                  onSelect(val)
                  onChange(value === val ? "" : val)
                }}
                error={!!error}
                disabled={loading || disabled}
                renderValue={(value) => multiple ? render ? render(value) : value.join(', ') : list?.find((item) => item.id === value)?.name}
                onOpen={onOpen}
                onClose={onClose}
                IconComponent={loading || (showClean && value) ? () => (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      setSelected(null)
                      onSelect(null)
                      onChange(null)
                      // field.onChange("");
                    }}
                  >
                    {loading ? <Loader /> : <Cancel />}
                  </IconButton>
                )
                  : undefined
                }
              >
                {list.map((item, i) => {
                  return (
                    <MenuItem id={name + item.name} key={"item_" + item.name + i} value={item.id}
                      sx={{
                        '&.MuiMenuItem-root': {
                          paddingY: 0
                        }
                      }}
                    >
                      {
                        multiple ? (
                          <>
                            <Checkbox
                              checked={selected?.indexOf(item.id) > -1}
                              checkedIcon={<Image src={Images.icon.check_square} />}
                              icon={<Image src={Images.icon.uncheck_square} />}
                            />
                            <ListItemText primary={item.name} />
                          </>
                        ) : item.name
                      }
                    </MenuItem>
                  )
                })}
              </SelectStyled>
              {error && (
                <FormHelperText sx={{ color: "#d32f2f" }}>
                  {required}
                </FormHelperText>
              )}
            </FormControl>
          )
        }}
      />
    </Grid>
  )
}

export default InputSelectFieldGrid